<div class="container">
    <div class="header" *ngIf="!isLoading">
        {{ 'system-settings.general.dialog.title' | translate }}
    </div>
    <div class="main" *ngIf="!isLoading">
        <div class="top-row-main">
            <app-channel-text-input
                [name]="DRAWING_ID"
                label="system-settings.general.dialog.input-label.drawing-id"
                [value]="data.drawingId"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.drawingId" />
            <app-simple-dropdown
                [name]="DEFAULT_LANGUAGE"
                [legend]="'system-settings.general.dialog.input-label.default-language'"
                [options]="commonLanguageOptions"
                [selectedOption]="currentLanguageLabel"
                (onOptionSelected)="onInputChange($event)">
            </app-simple-dropdown>
        </div>
        <div class="bottom-row-main">
            <app-simple-dropdown
                [name]="MASTER_CLOCK_TYPE"
                [legend]="'system-settings.general.dialog.input-label.systems-clock'"
                [options]="commonMasterClockOptions"
                [selectedOption]="masterClockTypeLabel"
                (onOptionSelected)="onInputChange($event)">
            </app-simple-dropdown>
            <div class="checkbox-wrapper">
                <mat-checkbox class="checkbox" [(ngModel)]="currentUtcEnable" (ngModelChange)="changeUtcEnable()">{{
                    'system-settings.general.dialog.checkbox-label.utc' | translate
                }}</mat-checkbox>
            </div>
        </div>
    </div>
    <div class="checkbox-container" *ngIf="!isLoading">
        <div class="checkbox-wrapper">
            <mat-checkbox
                class="checkbox"
                [(ngModel)]="currentJapanCoastGuard"
                (ngModelChange)="changeJapanCoastGuard()"
                *ngIf="data.isJrcsEmployee"
                >{{ 'system-settings.general.dialog.checkbox-label.jp-guard' | translate }}</mat-checkbox
            >
        </div>
    </div>
    <app-loading-spinner
        *ngIf="isLoading"
        class="spinner-component"
        [custom]="true"
        size="80"
        strokeWidth="3"></app-loading-spinner>
    <div class="footer">
        <div class="button-container">
            <button class="text-button" data-cy="ops-settings-system-setting-modal-cancel-button" (click)="close()">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                [disable]="disabledSaveButton()"
                text="Save settings"
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="saveCommon()"></app-button>
        </div>
    </div>
</div>
